import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WCreateVideoRequest, WUpdateVideoRequest } from '@zola/svc-web-api-ts-client';

import type { AppThunk } from 'reducers/index';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import { receiveEntityResponse, receiveUpdatedEntityResponse } from '../EntityActions';

export type CreateVideoRequestType = Pick<WCreateVideoRequest, 'caption' | 'url'>;
export type UpdateVideoRequestType = Pick<WUpdateVideoRequest, 'caption' | 'url' | 'video_id'>;

export function addVideo(
  createVideoRequest: CreateVideoRequestType,
  type: 'gallery' | 'home'
): AppThunk<Promise<void>> {
  return (dispatch): Promise<void> => {
    return ApiService.post<GenericEntityType>(
      `/web-api/v1/cms/page/${type === 'gallery' ? 'photo' : 'home'}/video/create`,
      createVideoRequest
    ).then((response: GenericEntityType) => {
      dispatch(receiveEntityResponse(response));
    });
  };
}

export function updateVideo(updateVideoRequest: UpdateVideoRequestType): AppThunk<Promise<void>> {
  return (dispatch): Promise<void> => {
    return ApiService.put<GenericEntityType>(
      `/web-api/v1/cms/page/photo/video/update`,
      updateVideoRequest
    ).then((response: GenericEntityType) => {
      dispatch(receiveUpdatedEntityResponse(response));
    });
  };
}
